import styled from 'styled-components';
import { darken } from 'polished'

export const AnchorStyled = styled.a`
  padding: ${props => props.padding || "10px 10px"};
  text-decoration: none;
  color: ${props => props.color || '#000000'};
  background-color: ${props => props.backgroundColor || "#ffffff"};
  border-radius: ${props => props.borderRadius || "0px"};
  margin-bottom: ${props => props.marginBottom || "0px"};
  width: ${props => props.width || "auto"};
  text-align: center;
  border: ${props => props.border || "none"};
  font-size: ${props => props.fontSize || "1rem"};
  font-weight: ${props => props.fontWeight || "normal"};

  transition: 300ms background-color ease;

  &:hover {
    background-color: ${
      props => darken(
        '0.1',
        `${props.backgroundColor ? props.backgroundColor : '#fff'}`)
      || "#fff"
    };
  }
`